// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xBaseTheme } from "@eisinc/XDL/types";
import { color, getSystemColor } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("common.ui9"),
        },
        typographyProps: {
            weight: fontConfig.weight.medium,
            css: css`
                letter-spacing: 0;
            `,
        },

        css: css`
            &.small > ${TypographyStyle} {
                font-size: ${fontConfig.singleLinexSmall.size}px;
                line-height: ${fontConfig.singleLinexSmall.lineHeight};
            }

            & ${IconWrapper} {
                opacity: 0.5;
                color: ${color("text.link")};
            }
            &[disabled] {
                cursor: not-allowed;
                & ${TypographyStyle} {
                    color: ${color("text.link", 0.33)};
                }
                & ${IconWrapper} {
                    opacity: 0.16;
                    color: ${color("text.link")};
                }
                &:hover {
                    ${IconWrapper} {
                        opacity: 0.16;
                        color: ${color("text.link")};
                    }
                }
            }
            &.hovered ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        `,
    },
} as xBaseTheme["link"];
